export const LANGUAGE_STRING_ID_MAP = {
  English: 'English',
  Chinese: '中文',
  Chinesetraditional: '繁體中文',
  Korean: '한국어',
  Hindi: 'हिन्दी',
  Tamil: 'தமிழ்',
  Kannada: 'ಕನ್ನಡ',
  Telugu: 'తెలుగు',
  Japanese: '日本語',
  Spanish: 'Español',
  Thai: 'ภาษาไทย',
  French: 'Français',
  Italian: 'Italiano',
  German: 'Deutsch',
  Portuguese: 'Português',
  Turkish: 'Türkçe',
  Arabic: 'العربية',
  Marathi: 'मराठी',
  Gujarati: 'ગુજરાતી',
  Bengali: 'বাংলা',
  Vietnamese: 'Tiếng Việt',
  Dutch: 'Nederlands',
  Polish: 'Polski',
  Swedish: 'Svenska',
  ISL: 'ISL',
};

export type InstanceLanguage = keyof typeof LANGUAGE_STRING_ID_MAP;
